module.exports = __webpack_public_path__ + "assets/img/hill-4.1f51b465.png";